import { Injectable, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import * as CryptoJS from 'crypto-js';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';

declare var Crypto: any;
declare var CryptoService: any;

@Injectable()
export class dashboardlandingpageservice {
  CryptoObj: any;
  cryptoService: any;
  result: any;
  constructor(private http: Http, private utilserv: utilityService) {
    this.CryptoObj = Crypto;
    this.cryptoService = new CryptoService();
  }

  //exchange rate

  getexchangerateservice(currencymodel): any {
    return this.utilserv.restPost(this.getexchangerateenvolpe(currencymodel), AppSettings.AgentManagementService + '/GetExchangeRate');
  }

  getProgramDetails(obj: any) {
    let serviceUrl = '';
    serviceUrl = AppSettings.CartActionItemServices + '/rest/GetPrograms';
    return this.utilserv.restPost(this.prepareEnvelopeProgramDetails(obj), serviceUrl);
  }
  prepareEnvelopeProgramDetails(reqObj: any) {
    //console.log("entra sin token")
    const envelope = {
      CurrencyCodeTo: reqObj.CurrencyCodeTo,
      LanguageCode: sessionStorage.langCode,
      Session: {
        T1: '',
        T2: sessionStorage.T2
      }
    };
    return JSON.stringify(envelope);
  }

  GetSuperSend(obj: any) {
    let serviceUrl = '';
    if (obj.page == 'summary') {
      serviceUrl = AppSettings.AgentManagementService + '/GetSuperSendAtSummary';
      return this.utilserv.restPost(this.prepareEnvelopeSuperSendAtSummary(obj), serviceUrl);
    } else {
      serviceUrl = AppSettings.AgentManagementService + '/GetSuperSend';
      return this.utilserv.restPost(this.prepareEnvelopeSuperSend(obj), serviceUrl);
    }
    // serviceUrl = AppSettings.AgentManagementService + '/GetSuperSend';
  }

  prepareEnvelopeSuperSend(reqObj: any) {
    const envelope = {
      ProgramId: reqObj.programs,
      Amount: reqObj.Amount,
      CurrencyCodeTo: reqObj.CurrencyCodeTo,
      LanguageCode: sessionStorage.langCode,
      DeliveryMethod: reqObj.DeliveryMethod,
      CountryCodeTo: reqObj.CountryCodeTo,
      CountryCodeFrom: reqObj.CountryCodeFrom,
      CurrencyCodeFrom: reqObj.CurrencyCodeFrom,
      Session: {
        T1: '',
        T2: sessionStorage.T2
      }
    };

    return JSON.stringify(envelope);
  }

  prepareEnvelopeSuperSendAtSummary(reqObj: any) {
    const envelope = {
      ProgramId: reqObj.programs,
      Amount: reqObj.Amount,
      CurrencyCodeTo: reqObj.CurrencyCodeTo,
      LanguageCode: sessionStorage.langCode,
      DeliveryMethod: reqObj.DeliveryMethod,
      LocationId: reqObj.LocationId,
      CountrySupportedCurrencyCodesTo: reqObj.CountrySupportedCurrencyCodesTo,
      CountryCodeTo: reqObj.CountryCodeTo,
      CountryCodeFrom: reqObj.CountryCodeFrom,
      CurrencyCodeFrom: reqObj.CurrencyCodeFrom,
      Session: {
        T1: '',
        T2: sessionStorage.T2
      }
    };

    return JSON.stringify(envelope);
  }

  getexchangerateenvolpe(currencymodel) {
    const envelope = `{
                        "CountryCodeFrom":"${currencymodel.CountryCodeFrom}",
                        "CountryCodeTo":"${currencymodel.CountryCodeTo}",
                        "CurrencyCodeFrom":"${currencymodel.CurrencyCodeFrom}",
                        "CurrencyCodeTo":"${currencymodel.CurrencyCodeTo}",
                        "DeliveryMethod":"${currencymodel.DeliveryMethod}",
                        "ProgramId":"${currencymodel.ProgramId}",
                        "LanguageCode":"${sessionStorage.langCode}",
                        "Session":{
                                "T1": "",
                                "T2":"${sessionStorage.T2}"
                        }


                    }`;
    return envelope;
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/dashboardservice/dash-board.service.ts